var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        { attrs: { inverted: "" } },
        [
          _c("q-toolbar-title", [
            _vm._v("\n      Tabele\n      "),
            _c("span", { attrs: { slot: "subtitle" }, slot: "subtitle" }, [
              _vm._v(
                "\n        wybór przypisanych do materiału tabel/wyszukiwarek\n      "
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "q-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dataItems.length > 0,
              expression: "dataItems.length>0"
            }
          ]
        },
        _vm._l(_vm.dataItems, function(item) {
          return _c(
            "q-item",
            { key: item.oid },
            [
              _c(
                "q-item-side",
                [
                  _c("q-toggle", {
                    on: {
                      input: function($event) {
                        return _vm.tableChange(item)
                      }
                    },
                    model: {
                      value: item.checked,
                      callback: function($$v) {
                        _vm.$set(item, "checked", $$v)
                      },
                      expression: "item.checked"
                    }
                  })
                ],
                1
              ),
              _c("q-item-main", {
                attrs: { label: item.name, sublabel: item.table }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }